import { createAction } from 'redux-actions';

export const setAllSubmissions = createAction('SET_ALL_SUBMISSIONS');